/* Beyours collection redesign — chip bar (AJAX) + grid toggle + swipe cards */
(function () {
  'use strict';

  function setHeaderOffset() {
    var h = document.querySelector('store-header, #shopify-section-header, .header, header[role="banner"]');
    var px = h ? Math.round(h.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--beyours-header-h', px + 'px');
  }
  setHeaderOffset();
  window.addEventListener('load', setHeaderOffset);
  window.addEventListener('resize', setHeaderOffset);

  function closeAll(except) {
    document.querySelectorAll('[data-cfb-chip]').forEach(function (wrap) {
      if (wrap === except) return;
      var btn = wrap.querySelector('[data-cfb-toggle]');
      var panel = wrap.querySelector('[data-cfb-panel]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }

  function buildUrlFromForm(form) {
    var fd = new FormData(form);
    var params = new URLSearchParams();
    fd.forEach(function (val, key) { if (val !== '' && val != null) params.append(key, val); });
    var qs = params.toString();
    return location.pathname + (qs ? '?' + qs : '');
  }

  function openChipIndex() {
    var wraps = document.querySelectorAll('[data-cfb-chip]');
    for (var i = 0; i < wraps.length; i++) {
      var b = wraps[i].querySelector('[data-cfb-toggle]');
      if (b && b.getAttribute('aria-expanded') === 'true') return i;
    }
    return -1;
  }
  function reopenChip(idx) {
    if (idx < 0) return;
    var wraps = document.querySelectorAll('[data-cfb-chip]');
    if (!wraps[idx]) return;
    var b = wraps[idx].querySelector('[data-cfb-toggle]');
    var p = wraps[idx].querySelector('[data-cfb-panel]');
    if (b) b.setAttribute('aria-expanded', 'true');
    if (p) p.hidden = false;
  }

  function fetchAndReplace(url, reopenIdx) {
    var list = document.querySelector('.product-facet__product-list');
    if (list) list.style.opacity = '0.45';
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nl = doc.querySelector('.product-facet__product-list');
        var cl = document.querySelector('.product-facet__product-list');
        if (nl && cl) cl.parentNode.replaceChild(nl, cl);
        var nb = doc.querySelector('collection-filter-bar');
        var cb = document.querySelector('collection-filter-bar');
        if (nb && cb) cb.parentNode.replaceChild(nb, cb);
        var nc = doc.querySelector('.product-facet__meta-bar-item--count');
        var cc = document.querySelector('.product-facet__meta-bar-item--count');
        if (nc && cc) cc.textContent = nc.textContent;
        history.pushState({ cfb: 1 }, '', url);
        boot();
        reopenChip(typeof reopenIdx === 'number' ? reopenIdx : -1);
        if (window.__cfcBootCards) window.__cfcBootCards();
      })
      .catch(function () { location.href = url; });
  }

  var applyTimer = null;
  function applyFromForm(form) {
    var idx = openChipIndex();
    clearTimeout(applyTimer);
    applyTimer = setTimeout(function () { fetchAndReplace(buildUrlFromForm(form), idx); }, 220);
  }

  function initBar(bar) {
    var form = bar.querySelector('[data-cfb-form]');

    bar.querySelectorAll('[data-cfb-chip]').forEach(function (wrap) {
      var btn = wrap.querySelector('[data-cfb-toggle]');
      var panel = wrap.querySelector('[data-cfb-panel]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = btn.getAttribute('aria-expanded') === 'true';
        closeAll(wrap);
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
      });
      panel.addEventListener('click', function (e) { e.stopPropagation(); });
    });

    /* size group checkbox toggles its hidden member checkboxes (fires before form change) */
    bar.querySelectorAll('.cfb-size-group').forEach(function (g) {
      g.addEventListener('change', function () {
        var li = g.closest('li');
        if (li) li.querySelectorAll('.cfb-size-member').forEach(function (m) { m.checked = g.checked; });
      });
    });

    /* AUTO-APPLY: any checkbox change re-filters (debounced, keeps dropdown open) */
    if (form) form.addEventListener('change', function () { applyFromForm(form); });

    /* per-panel Clear */
    bar.querySelectorAll('[data-cfb-panel-clear]').forEach(function (c) {
      c.addEventListener('click', function () {
        var panel = c.closest('[data-cfb-panel]');
        if (panel) panel.querySelectorAll('input[type=checkbox]').forEach(function (cb) { cb.checked = false; });
        if (form) applyFromForm(form);
      });
    });

    /* active-chip removals */
    bar.querySelectorAll('[data-cfb-remove-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        var tok = b.getAttribute('data-cfb-remove-size');
        var g = bar.querySelector('.cfb-size-group[data-size-tok="' + tok + '"]');
        if (g) { g.checked = false; var li = g.closest('li'); if (li) li.querySelectorAll('.cfb-size-member').forEach(function (m) { m.checked = false; }); }
        if (form) applyFromForm(form);
      });
    });
    bar.querySelectorAll('[data-cfb-remove-name]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.getAttribute('data-cfb-remove-name'), v = b.getAttribute('data-cfb-remove-value');
        var esc = v.replace(/(["\\])/g, '\\$1');
        var inp = bar.querySelector('input[name="' + n + '"][value="' + esc + '"]');
        if (inp) inp.checked = false;
        if (form) applyFromForm(form);
      });
    });
    var clearAll = bar.querySelector('[data-cfb-clear-all]');
    if (clearAll) clearAll.addEventListener('click', function () {
      bar.querySelectorAll('input[type=checkbox]').forEach(function (cb) { cb.checked = false; });
      if (form) applyFromForm(form);
    });

    /* grid toggle */
    var toggle = bar.querySelector('[data-cfb-grid-toggle]');
    if (toggle) toggle.querySelectorAll('[data-cols]').forEach(function (b) {
      b.addEventListener('click', function () { applyCols(b.getAttribute('data-cols'), true); });
    });
  }

  function applyCols(cols, persist) {
    if (cols !== '1' && cols !== '2' && cols !== '3') cols = '2';
    document.querySelectorAll('.product-list__inner').forEach(function (g) { g.setAttribute('data-cols', cols); });
    document.querySelectorAll('[data-cfb-grid-toggle] [data-cols]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-cols') === cols ? 'true' : 'false');
    });
    if (persist) { try { localStorage.setItem('beyours_grid_cols', cols); } catch (e) {} }
  }
  function initCols() {
    var stored = '2';
    try { stored = localStorage.getItem('beyours_grid_cols') || '2'; } catch (e) {}
    applyCols(stored, false);
  }

  document.addEventListener('click', function () { closeAll(null); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
  window.addEventListener('popstate', function () { fetchAndReplace(location.pathname + location.search); });

  function boot() {
    document.querySelectorAll('[data-cfb]').forEach(initBar);
    initCols();
    setHeaderOffset();
  }
  window.__cfbBoot = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* ---- Product card: swipe dots, lazy media, chevrons, drag-vs-tap ---- */
(function () {
  'use strict';
  var THRESH = 10;

  function injectLazy(card) {
    card.querySelectorAll('img[data-cfc-lazy]').forEach(function (img) {
      img.src = img.getAttribute('data-cfc-lazy');
      var ss = img.getAttribute('data-srcset');
      if (ss) img.srcset = ss;
      img.removeAttribute('data-cfc-lazy');
    });
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { injectLazy(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '200px' }) : null;

  function initCard(card) {
    if (card.__cfcInit) return; card.__cfcInit = true;
    var track = card.querySelector('[data-cfc-track]');
    var dots = card.querySelectorAll('[data-cfc-dots] .cfc__dot');
    var swipe = card.querySelector('[data-cfc-swipe]');
    if (io) io.observe(card); else injectLazy(card);
    if (swipe) swipe.addEventListener('pointerdown', function () { injectLazy(card); }, { once: true, passive: true });
    if (track && dots.length) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
          ticking = false;
        });
      }, { passive: true });
    }
    var prev = card.querySelector('[data-cfc-prev]');
    var next = card.querySelector('[data-cfc-next]');
    function nav(e, dir) { e.preventDefault(); e.stopPropagation(); if (track) track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function (e) { nav(e, -1); });
    if (next) next.addEventListener('click', function (e) { nav(e, 1); });
    if (swipe) {
      var sx = 0, sy = 0, moved = false;
      swipe.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; moved = false; }, { passive: true });
      swipe.addEventListener('pointermove', function (e) { if (Math.abs(e.clientX - sx) > THRESH || Math.abs(e.clientY - sy) > THRESH) moved = true; }, { passive: true });
      var link = card.querySelector('.cfc__link');
      if (link) link.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    }
  }
  function bootCards() { document.querySelectorAll('[data-cfc-card]').forEach(initCard); }
  window.__cfcBootCards = bootCards;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootCards); else bootCards();
  document.addEventListener('shopify:section:load', bootCards);
})();
